import { render, staticRenderFns } from "./ViewCompanies.vue?vue&type=template&id=8061d01e&scoped=true&"
import script from "./ViewCompanies.vue?vue&type=script&lang=js&"
export * from "./ViewCompanies.vue?vue&type=script&lang=js&"
import style0 from "./ViewCompanies.vue?vue&type=style&index=0&id=8061d01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8061d01e",
  null
  
)

export default component.exports